const answers = [
  'DUINE',
  'ABAIR',
  'MAITH',
  'FAIGH',
  'TÉIGH',
  'NUAIR',
  'AMACH',
  'CEANN',
  'CAITH',
  'CHOMH',
  'CHUIG',
  'OBAIR',
  'TAOBH',
  'ANOIS',
  'CÉILE',
  'TEACH',
  'CEART',
  'SCÉAL',
  'ROIMH',
  'CEIST',
  'ANSIN',
  'DÓIGH',
  'POBAL',
  'SCOIL',
  'ROINN',
  'ÚSÁID',
  'LEITH',
  'ANSEO',
  'OÍCHE',
  'BAILE',
  'LUCHT',
  'CÚRSA',
  'EOLAS',
  'IMIGH',
  'CAINT',
  'ÁBHAR',
  'FÉACH',
  'SIÚIL',
  'ÉIGIN',
  'BUAIL',
  'RIAMH',
  'FOCAL',
  'BEIRT',
  'MEASC',
  'CLOIS',
  'CÓNAÍ',
  'THART',
  'MINIC',
  'ANUAS',
  'IONAD',
  'UISCE',
  'GEALL',
  'CÚPLA',
  'CÚIRT',
  'DORAS',
  'OIFIG',
  'CÓRAS',
  'MÓRÁN',
  'SÁSTA',
  'INNIU',
  'SUIGH',
  'BREIS',
  'SRÁID',
  'CAILL',
  'GEARR',
  'ÁFACH',
  'CREID',
  'LUATH',
  'GRÚPA',
  'FADHB',
  'SCÉIM',
  'SEANS',
  'BOCHT',
  'THIAR',
  'TUILL',
  'LACHA',
  'GAOTH',
  'DREAM',
  'CUMAS',
  'TRÁTH',
  'CLANN',
  'STAIR',
  'CÚRAM',
  'ATHRÚ',
  'TOISC',
  'CRANN',
  'PÁIRT',
  'CLOCH',
  'SOLAS',
  'FOIRM',
  'LITIR',
  'PLEAN',
  'PÁIRC',
  'LÉANN',
  'ROGHA',
  'LEATH',
  'FÉILE',
  'UASAL',
  'CONAS',
  'LÉIGH',
  'GRIAN',
  'DÓCHA',
  'PÍOSA',
  'THÍOS',
  'FÓILL',
  'TURAS',
  'LUIGH',
  'BEITH',
  'RIAIL',
  'FÓGRA',
  'THUAS',
  'BEART',
  'LÉAMH',
  'DEARA',
  'SIOPA',
  'LEABA',
  'DEICH',
  'DEARG',
  'EAGLA',
  'BAINT',
  'GARDA',
  'DRÁMA',
  'FICHE',
  'LUACH',
  'RÉIDH',
  'NEART',
  'TRIÚR',
  'AONAR',
  'MARBH',
  'DEOCH',
  'GREIM',
  'FOSTA',
  'DALTA',
  'DROIM',
  'TROID',
  'BHUEL',
  'ÓCÁID',
  'TUATH',
  'BRATH',
  'CIALL',
  'AIRDE',
  'FORAS',
  'SPÉIS',
  'INÍON',
  'SPÓRT',
  'GNÁTH',
  'BRONN',
  'SOCRÚ',
  'BLÁTH',
  'THALL',
  'ÍSEAL',
  'GLÚIN',
  'AIGNE',
  'EARRA',
  'AONAD',
  'DUAIS',
  'BALLA',
  'MEALL',
  'ANÍOS',
  'BILLE',
  'NOCHT',
  'AIDHM',
  'GÁIRE',
  'SPÉIR',
  'BREAC',
  'EASPA',
  'GALAR',
  'GASÚR',
  'CIÚIN',
  'BOSCA',
  'THEAS',
  'URLÁR',
  'IOMAÍ',
  'TEANN',
  'CROCH',
  'FÓRSA',
  'MADRA',
  'LAOCH',
  'LEASÚ',
  'CÓSTA',
  'CRUTH',
  'ÁTHAS',
  'ANONN',
  'TÉACS',
  'FEIRM',
  'HALLA',
  'ARAON',
  'GLÉAS',
  'MISTE',
  'BRÉAG',
  'GUNNA',
  'CAORA',
  'ANIAR',
  'DEARC',
  'MOILL',
  'SNÁMH',
  'CNÁMH',
  'GÉILL',
  'CAOIN',
  'DRUGA',
  'CÁRTA',
  'ACHAR',
  'CÚIGE',
  'IONAS',
  'BÁIGH',
  'SRUTH',
  'FEOIL',
  'DÍLIS',
  'LOCHT',
  'ÉADAN',
  'RÚNAÍ',
  'STAID',
  'ÉASCA',
  'SCAIP',
  'AISTE',
  'SCOTH',
  'DRUID',
  'CISTE',
  'TÉAMA',
  'TAIRG',
  'OCRAS',
  'MAÍGH',
  'DEOIR',
  'SEINN',
  'SONRA',
  'TOBAR',
  'BÉILE',
  'COILL',
  'ÓSTÁN',
  'MAOIN',
  'ACHAN',
  'NÁIRE',
  'BUNÚS',
  'ANALL',
  'GNÁCH',
  'SCÁTH',
  'TRÉIG',
  'MÉADÚ',
  'CRAOL',
  'ÍOMHÁ',
  'OTHAR',
  'AICME',
  'FUAIM',
  'GAIRM',
  'SÁIGH',
  'TIRIM',
  'BÁIRE',
  'CEIRD',
  'GARBH',
  'GEATA',
  'LIATH',
  'MAIDE',
  'NAOFA',
  'UAIGH',
  'CLUIN',
  'DABHT',
  'BRAON',
  'UAFÁS',
  'TÁBLA',
  'TRÉAN',
  'BANNA',
  'CAIRT',
  'CLUAS',
  'BINSE',
  'ANÁIL',
  'NEAMH',
  'NÁDÚR',
  'FÁSTA',
  'COSÁN',
  'ARDÁN',
  'FEADH',
  'FEARG',
  'CÚLRA',
  'AISCE',
  'PEANN',
  'SRIAN',
  'ARÉIR',
  'CAITE',
  'CLAON',
  'GORTA',
  'FIACH',
  'CASTA',
  'DLÚTH',
  'CAOGA',
  'MÍNIÚ',
  'PÉIRE',
  'LÁIGH',
  'RINCE',
  'BARRA',
  'CEARC',
  'SCUAB',
  'PRÁTA',
  'NAOMH',
  'CLEAS',
  'RUAIG',
  'GUIGH',
  'SCOIR',
  'ARMAS',
  'FIÁIN',
  'PEACA',
  'PREAB',
  'TAISE',
  'SCÁLA',
  'GRINN',
  'BRÁCH',
  'ONÓIR',
  'BUILE',
  'TITIM',
  'AGÓID',
  'SACAR',
  'COLÚN',
  'BRÉAN',
  'TEITH',
  'EAGAR',
  'RÍOGA',
  'EOLAÍ',
  'PÓSTA',
  'ABHUS',
  'FUATH',
  'RÍOMH',
  'DÍOMÁ',
  'CUPÁN',
  'BUÍON',
  'GLEIC',
  'ÉACHT',
  'DLIGH',
  'SCIAN',
  'FÁISC',
  'PLÁTA',
  'ITHIR',
  'IOMAD',
  'DÍBIR',
  'SCÁIL',
  'EITIL',
  'FEITH',
  'TOBAC',
  'FIONN',
  'CRITH',
  'TEIST',
  'BRÁID',
  'LÉINE',
  'SCATA',
  'GIOTA',
  'FEALL',
  'SCAIR',
  'TOIRT',
  'SCIOB',
  'DAITE',
  'RÉIGH',
  'COGAR',
  'TANAÍ',
  'OIBRÍ',
  'SUITE',
  'MUISE',
  'CAMPA',
  'RÚNDA',
  'TOGHA',
  'DÚNTA',
  'CLÉIR',
  'GNÉAS',
  'GASTA',
  'TÁIRG',
  'ALLAS',
  'SÁILE',
  'DOIRT',
  'DÚLRA',
  'TIUBH',
  'FINNÉ',
  'BOTÚN',
  'ALBAM',
  'PÍOPA',
  'TOGRA',
  'ÓRÁID',
  'BLAIS',
  'SEACH',
  'NEACH',
  'FAILL',
  'MILIS',
  'TARBH',
  'MÚNLA',
  'MÉARA',
  'FÍRIC',
  'BUAMA',
  'BAIST',
  'CRIOS',
  'LEAID',
  'MEATH',
  'AOSTA',
  'SEILG',
  'GOILL',
  'SÉIMH',
  'SCÍTH',
  'PUINN',
  'RIALÚ',
  'GADAÍ',
  'MAISE',
  'IMIRT',
  'OCHTÓ',
  'CRAIC',
  'OLANN',
  'SÚIGH',
  'DOCHT',
  'AILSE',
  'CANNA',
  'FAIRE',
  'CAOCH',
  'SÍODA',
  'EADAR',
  'CUMHA',
  'CAIFE',
  'SÓLÁS',
  'SÁITH',
  'RÁFLA',
  'CUACH',
  'AIRNE',
  'ALCÓL',
  'LUIBH',
  'TNÚTH',
  'CEARR',
  'TACHT',
  'TUILE',
  'BEACH',
  'ÉINDÍ',
  'ANOIR',
  'SCIAR',
  'PLÁNA',
  'BEOLA',
  'CREAT',
  'CRÓGA',
  'MOTHÚ',
  'THUSA',
  'AOIBH',
  'SICÍN',
  'BEARR',
  'FÉITH',
  'ORTHA',
  'FORÁS',
  'MASLA',
  'CÓNRA',
  'TRIAN',
  'DHEIN',
  'CEILT',
  'TOSAÍ',
  'STAON',
  'GOILE',
  'TUAMA',
  'UACHT',
  'PEATA',
  'LAIGE',
  'STOCA',
  'FRÁMA',
  'SCAIF',
  'DRAOI',
  'BEANN',
  'GLÓIR',
  'TEILG',
  'PÉIST',
  'LUASC',
  'CATHÚ',
  'SÉALA',
  'RACHT',
  'ÍDIGH',
  'SNÁTH',
  'UAIMH',
  'CASÓG',
  'OILTE',
  'SMIOR',
  'CÚISÍ',
  'CÍSTE',
  'IREAS',
  'TARLÚ',
  'BALBH',
  'COTHÚ',
  'PÚDAR',
  'SONAS',
  'SEIFT',
  'BEOIR',
  'LAMPA',
  'MEAIG',
  'CAIFÉ',
  'ÉIRIM',
  'STRAE',
  'MAMAÍ',
  'UMHAL',
  'MIONN',
  'CÍOCH',
  'COISC',
  'TUATA',
  'TÉAMH',
  'INMHE',
  'DREAP',
  'BHEIR',
  'UATHA',
  'SEILF',
  'LEOGA',
  'NÓCHA',
  'GONTA',
  'IOMRÁ',
  'DREAS',
  'DÉIRC',
  'ADAMH',
  'DÍOBH',
  'GREAD',
  'LEANN',
  'OLCAS',
  'URNAÍ',
  'GORTÚ',
  'CEARN',
  'IOLRA',
  'GNÚIS',
  'PÉINT',
  'STAIC',
  'BUAIR',
  'TOCHT',
  'FOSTÚ',
  'URRÚS',
  'LEAMH',
  'DÓITE',
  'TOISE',
  'DAIDÍ',
  'GEALT',
  'TONNA',
  'FOCLA',
  'SAINT',
  'GREAN',
  'AOIRE',
  'NÉATA',
  'ORDÓG',
  'LIOPA',
  'FINNE',
  'ÚRNUA',
  'TRÉAD',
  'CÉIMÍ',
  'CREIM',
  'SPOTA',
  'DONAS',
  'COIRM',
  'CAMÁN',
  'LEOMH',
  'CHÓIR',
  'IDÉAL',
  'DÍNIT',
  'CIPÍN',
  'SAILL',
  'FÓCAS',
  'CÓFRA',
  'ASPAL',
  'PÁLÁS',
  'CLAIS',
  'SLIOS',
  'FÓNTA',
  'COPAR',
  'AICÍD',
  'SPÍON',
  'STUIF',
  'GIALL',
  'COIRE',
  'DIAGA',
  'GRÁIN',
  'BÁÚIL',
  'SODAR',
  'MODÚL',
  'DEASC',
  'DEOIN',
  'UAINE',
  'BUAIC',
  'STRUS',
  'ÉIGSE',
  'PUTÓG',
  'LOISC',
  'LÍOMH',
  'ANEAS',
  'CLÁRÚ',
  'SEOID',
  'DAOFA',
  'FÁSRA',
  'DRUMA',
  'IONGA',
  'BOGHA',
  'TRÁTA',
  'BACÁN',
  'TACAR',
  'CASÚR',
  'ROLLA',
  'CLÚMH',
  'LEASC',
  'LÍOFA',
  'GRÉAS',
  'SLÁNÚ',
  'PLÚCH',
  'DEALG',
  'PREAS',
  'CUING',
  'ALLTA',
  'CORCA',
  'IOLAR',
  'ARANN',
  'SFÉAR',
  'FUAID',
  'DRÉIM',
  'TEIBÍ',
  'GÁTAR',
  'PRIOC',
  'SPRID',
  'SMÉAR',
  'GOTHA',
  'PLUID',
  'COLÚR',
  'DÁIMH',
  'SÍNIÚ',
  'LIONN',
  'FÁIDH',
  'ATHRÁ',
  'FRÁSA',
  'GOIRT',
  'MÉITH',
  'ORGÁN',
  'SOLAD',
  'MATÁN',
  'SMÉID',
  'GABHA',
  'BÁBÓG',
  'CÁBÁN',
  'TAISC',
  'TARNA',
  'AGAIR',
  'FIUCH',
  'FOLÚS',
  'RIBÍN',
  'SÚGÁN',
  'BANBH',
  'STAIL',
  'CNEAS',
  'LEACA',
  'THOIR',
  'EAGAL',
  'CRUAS',
  'SCÓIP',
  'PRÓCA',
  'CRAOS',
  'FAIDE',
  'CADÁS',
  'GLINN',
  'PLAIC',
  'CAILC',
  'LUAIL',
  'CORDA',
  'NUIGE',
  'CLÚID',
  'ÁIRID',
  'GIÚIS',
  'ÉIRIC',
  'SEODA',
  'CRUIT',
  'BIÚRÓ',
  'CHAON',
  'SMEAR',
  'MÓTAR',
  'FIDIL',
  'STRAC',
  'PLOTA',
  'CUÓTA',
  'ÍOSTA',
  'CLÓCA',
  'BLIGH',
  'GASRA',
  'LÚFAR',
  'SÁINN',
  'SUIRÍ',
  'GEÁBH',
  'CREIG',
  'DRONG',
  'CÁBLA',
  'TIÚIN',
  'RUBAR',
  'TEORA',
  'IARLA',
  'LADAR',
  'GÉIRE',
  'CEADÚ',
  'PÉINE',
  'LAGAR',
  'TÁTAL',
  'FEANN',
  'DEILF',
  'MACHA',
  'OISRE',
  'BANDA',
  'SMÚIT',
  'BRÍCE',
  'STÉIG',
  'CÓGAS',
  'BAGÚN',
  'GAOIS',
  'SEASC',
  'DARNA',
  'SCINN',
  'SCRIÚ',
  'EORNA',
  'GRÍOS',
  'BOLTA',
  'LASTA',
  'ÁIRSE',
  'EASNA',
  'RIASC',
  'PUNTA',
  'INÍOR',
  'ACLAÍ',
  'CRÁIN',
  'COIRT',
  'CUNTA',
  'TACAÍ',
  'TREIS',
  'SCEAN',
  'TRÚPA',
  'CEIRT',
  'CÉILÍ',
  'FOGHA',
  'SPOCH',
  'CASLA',
  'EAGNA',
  'GOBÁN',
  'ISPÍN',
  'ÚRACH',
  'BABAÍ',
  'SEILE',
  'THÉID',
  'FEART',
  'UAILL',
  'TREAS',
  'IAIGH',
  'FISIC',
  'SCALL',
  'ÍSLIÚ',
  'CLING',
  'GNAOI',
  'MEIRG',
  'LIRIC',
  'SEANG',
  'FRÍTH',
  'CEALG',
  'CEILP',
  'GALÚN',
  'CODÁN',
  'TROSC',
  'CÍRÍN',
  'FAOMH',
  'LEICE',
  'OCHTÚ',
  'DÓLÁS',
  'SCRÍN',
  'SCEON',
  'DIAIL',
  'PIANÓ',
  'SCÉIN',
  'TAOSC',
  'FLOSC',
  'SOBAL',
  'CROBH',
  'MÁNLA',
  'DÉINE',
  'PRÓIS',
  'TEARC',
  'EASÓG',
  'BAILÍ',
  'MARÓG',
  'GOIMH',
  'SCOLB',
  'SONRÚ',
  'MNAOI',
  'SRANN',
  'EITIC',
  'BÁITH',
  'TIGHE',
  'LEITE',
  'SEARR',
  'BAOTH',
  'CALMA',
  'FÁILÍ',
  'CRÚCA',
  'CURFÁ',
  'SLINN',
  'MÚNLÚ',
  'CRÍON',
  'TARRA',
  'FÍOCH',
  'BUACH',
  'CORNA',
  'BARDA',
  'ÉIDIR',
  'SNIGH',
  'BEOGA',
  'BÁSTA',
  'FUÁIL',
  'CAMAS',
  'SPEAL',
  'COISÍ',
  'SCIÚR',
  'TÓRAÍ',
  'DÍLEÁ',
  'SPALP',
  'CEANT',
  'FÁNAÍ',
  'SAOBH',
  'BRÁTH',
  'SEARG',
  'FALLA',
  'DRÚIS',
  'SLÍOC',
  'GRÁIG',
  'OIBIR',
  'FALSA',
  'TRÉAS',
  'RADAR',
  'OIDHE',
  'BREAB',
  'MATAL',
  'BAOIS',
  'MARAÍ',
  'BÁCÚS',
  'EILIT',
  'CNEAD',
  'DRANN', // Friday 22nd December
  'SCUAD',
  'BALÚN',
  'GAIBH',
  'ÁRACH',
  'BULAÍ',
  'SANAS',
  'GUAIM',
  'DUSTA',
  'CUAIN',
  'PLIMP',
  'OCHÓN',
  'STÁIR',
  'IOMPÚ',
  'BOIGE',
  'SILÍN',
  'DOIRE', // Monday 1st January
  'RANGÚ',
  'LÉANA',
  'CANTA',
  'BÁINÍ',
  'SEORT',
  'DALBA',
  'SEARC',
  'CASÁN',
  'TOILL',
  'TRUNC',
  'CUMAR',
  'ANÁLÚ',
  'SCÁIN',
  'SCINE',
  'CUILT',
  'MUIRÍ',
  'TRÚIG',
  'LACHT',
  'CÁITH',
  'SOTAL',
  'MÚISC',
  'CURAÍ',
  'BUIRG',
  'RACÁN',
  'LÉIMT',
  'BRÁCA',
  'STRÓC',
  'LÁBÁN',
  'COLPA',
  'OGHAM',
  'LONNÚ',
  'CALÓG',
  'CÉIDE',
  'DAMNÚ',
  'DLAOI',
  'EIPIC',
  'AIBÍD',
  'MOING',
  'LORGA',
  'BULLA',
  'STÁCA',
  'PAILM',
  'CAISE',
  'STIÚG',
  'POLLA',
  'SLEÁN',
  'MUINE',
  'FONSA',
  'PLUMA',
  'BÓLAÍ',
  'BURLA',
  'TEASC',
  'UASTA',
  'DÍLSE',
  'DRAID',
]

export default answers
